import { Controller } from "stimulus"
import axios from 'axios';
export default class extends Controller {
  static get targets() {
    return ['win', 'location', 'overstock', 'qty', 'debug'];
  }

  connect(){
    this.winTarget.focus(); 
     const csrfToken = document.querySelector("meta[name=csrf-token]").content
     axios.defaults.headers.common['X-CSRF-Token'] = csrfToken
     axios.defaults.headers.common['Accept'] = 'application/json';
     this.debug = this.data.has('debug'); 
  }

  findProduct(){
    let  t= this; 
    axios.get(this.data.get('url') + '/' + this.winTarget.value).then(function(response){
      t.loadProduct(response.data); 
      t.locationTarget.focus(); 
      t.locationTarget.select();
      }).catch(function(err){
        alert(err.response.data.error); 
        t.winTarget.select()
      }) 

  }

  updateField(field_name, target){
  let data = {} 
  data[field_name] = target.value
  let  t= this; 
    axios.put(this.data.get('url') + '/' + this.winTarget.value, data).then(function(response){
      t.loadProduct(response.data); 
      t.winTarget.focus(); 
      t.winTarget.select()
      }).catch(function(err){
        console.log(err.response.data.error);
      })
  }

  setNoPick(){
    let  t= this; 
    axios.put(this.data.get('url') + '/' + this.winTarget.value, {
      products_stock_location: 'NO PICK', 
      products_backstock_location: ''
    }).then(function(response){
      t.loadProduct(response.data); 
      t.winTarget.focus(); 
      t.winTarget.select()
      }).catch(function(err){
        console.log(err.response.data.error);
      })
  }


  handleInput(e){
    if (this.debug) {
      let html = this.debugTarget.innerHTML; 
      html = e.key + ", " + html; 
      this.debugTarget.innerHTML = html; 

    }

    if (e.code === 'Enter' || e.key === 'Enter') {
     e.preventDefault()
     e.stopImmediatePropagation(); 
      switch(e.target){
        case this.winTarget: 
          this.findProduct();
          break;
        case this.locationTarget: 
          this.updateField('products_stock_location', this.locationTarget);
          break;
        case this.qtyTarget: 
          this.updateField('products_quantity', this.qtyTarget);
          break;
        case this.overstockTarget: 
          this.updateField('products_backstock_location', this.overstockTarget);
          break;
         }
    }
  }

  loadProduct(data){
    let  t = this;
    Object.keys(data).forEach(function(d){
      t[d + 'Target'].value = data[d]; 
    })
  }

}




// WEBPACK FOOTER //
// ./app/javascript/rmrc_ad/controllers/quick_audits_controller.js